import { jsx as i } from "react/jsx-runtime";
import { c as s } from "react/compiler-runtime";
import { Paper as f } from "@mui/material";
import { forwardRef as l } from "react";
const d = l((t, m) => {
  const r = s(7);
  let o, e;
  r[0] !== t ? ({
    children: o,
    ...e
  } = t, r[0] = t, r[1] = o, r[2] = e) : (o = r[1], e = r[2]);
  let p;
  return r[3] !== o || r[4] !== e || r[5] !== m ? (p = /* @__PURE__ */ i(f, { ref: m, ...e, children: o }), r[3] = o, r[4] = e, r[5] = m, r[6] = p) : p = r[6], p;
});
export {
  d as Paper
};
